/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  area_division_id: z.number(),
  work_type_id: z.number(),
  name: z.string(),
  unit: z.string(),
  primary_work_detail_id: z.number().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const WorkSubtypeBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type WorkSubtypeBase = z.infer<typeof base>;
export type WorkSubtypeBasePutPayload = z.infer<typeof put>;
export type WorkSubtypeBasePatchPayload = z.infer<typeof patch>;
export type WorkSubtypeBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type WorkSubtypeBaseCreateAttributes = z.infer<typeof create>;
export type WorkSubtypeBaseUpdateAttributes = z.infer<typeof update>;
export type WorkSubtypeBaseCacheAttributes = z.infer<typeof cache>;
export type WorkSubtypeBaseCachesAttributes = z.infer<typeof caches>;